const e = {
  id: "TristateGimme5",
  name: "Gimme 5",
  style: {
    colorPrimary: "#ff008c"
  }
};
export {
  e as default
};
